import React from 'react';

interface FileUploadProps {
    id?: string;
    testid?: string;
    name?: string;
    className?: string;
    accept?: string;
    disabled?: boolean;
    multiple?: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onClick?: React.InputHTMLAttributes<HTMLInputElement>['onClick'];
}

const FileUpload: React.FC<FileUploadProps> = (props) => {
    const {
        id,
        testid,
        name,
        className,
        disabled,
        onChange,
        onClick,
        accept = 'image/png, image/jpeg, image/bmp',
        multiple = false,
    } = props;

    const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e);
        // Clear the input after so it can be uploaded again (if they so choose);
        e.target.value = '';
    };

    return (
        <input
            id={id}
            data-testid={testid}
            name={name}
            className={`hidden-input ${className}`}
            type='file'
            onChange={upload}
            onClick={onClick}
            disabled={disabled}
            accept={accept}
            multiple={multiple}
        />
    );
};

export default React.memo(FileUpload);
